import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Typography,
  Alert
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useTranslation } from "react-i18next";

const NO_CONTAINER_COLOR = "#DDDDDD";

const ContainerList = ({ groupedByLoading }) => {
  const { t } = useTranslation();

  return (
    <Box
      flex={1}
      sx={{
        maxHeight: "80vh",
        minWidth: "20vh",
        overflowY: "auto",
        borderRight: 1,
        borderColor: "divider",
        "&::-webkit-scrollbar": { width: 0 },
        scrollbarWidth: "none",
        "-ms-overflow-style": "none"
      }}
    >
      <List dense disablePadding>
        {Object.entries(groupedByLoading).map(([terminalName, containers]) => (
          <li key={terminalName}>
            <ListSubheader sx={{ bgcolor: "#C1D8F2", fontWeight: 700 }}>
              {terminalName} ({containers.length})
            </ListSubheader>
            {containers.map((c) => (
              <ListItem key={c["@id"]}>
                <ListItemText
                  primary={`${t("uid", "UID")}: ${c.uid || "—"}`}
                  secondary={
                    <Box display="flex" flexDirection="column" gap={0.5}>
                      <Typography
                        component="span"
                        variant="body2"
                        display="flex"
                        alignItems="center"
                        gap={1}
                      >
                        {c.loadingTerminal?.name}
                        <ArrowRightAltIcon fontSize="small" color="primary" />
                        {c.unloadingTerminal?.name}
                      </Typography>
                      <Typography variant="caption">
                        {`${t("weight", "Weight")}: ${c.weight || "—"} | ${t("type", "Type")}: ${c.containerType?.name || "—"}`}
                      </Typography>
                      {(c.loadingTerminalCall || c.unloadingTerminalCall) && (
                        <Alert severity="info" icon={false} sx={{ padding: '5px!important' }}>
                          <Box display="flex" flexDirection="column" sx={{ padding: '0!important' }}>
                            {c.loadingTerminalCall?.terminal?.name && (
                              <Typography variant="caption" color="text.secondary" noWrap>
                                <strong>{t("loadingPlan", "Loading plan")}:</strong> {c.loadingTerminalCall.terminal.name}
                              </Typography>
                            )}
                            {c.unloadingTerminalCall?.terminal?.name && (
                              <Typography variant="caption" color="text.secondary" noWrap>
                                <strong>{t("unloadingPlan", "Unloading plan")}:</strong> {c.unloadingTerminalCall.terminal.name}
                              </Typography>
                            )}
                          </Box>
                        </Alert>
                      )}
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </li>
        ))}
      </List>
    </Box>
  );
};

export default ContainerList;
